import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as fnbActions from './../../../../../../actions/fnbAction';
import OutletDetail from './OutletDetail';

const mapStateToProps = state => {
    return {
        fnbState: state.fnbReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getItemDetail: (filters) => dispatch(fnbActions.getItemDetail(filters)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(OutletDetail));
